// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rkZy","disabled":"styles_disabled__3M6_d"};